import React from 'react'
import { Typography } from '@mui/material'
import { Modal } from '../../_EOS/Modal'

interface DispatchConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  workOrderId?: number
  isLoading?: boolean
}

export const DispatchConfirmModal: React.FC<DispatchConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  workOrderId,
  isLoading = false
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title='Despachar OT'
      maxWidth='xs'
      loading={isLoading}
      cancelButton={{ title: 'Cancelar', action: onClose }}
      successButton={{ title: 'Confirmar', action: onConfirm }}
    >
      <Typography>{`¿Está seguro que desea Despachar OT N° ${workOrderId}?`}</Typography>
    </Modal>
  )
}
